const affirmationProgramEnumerators = {
  type: ['Standard', '21-Day Focus', 'Deep Dive'],
};

export default affirmationProgramEnumerators;
